/* eslint-disable no-use-before-define */
import React from 'react'
import { getId, show, } from '../../twd'

export default ({name, form, push, remove, ...x}) => {
    let values = form.values[name] || []

    let err = form.errors && form.errors[name]

    return (
    <div className={'advanced-screener-search-form-securites-field filter-group' + (err ? ' has-error': '')}>
    {(invTypes.map( (a,i) => {
        const id = getId()
        return (
        <div className="filter" key={i}>
        <input
            data-name="advanced-screener-security-type"
            name="invType"
            id={id}
            type="checkbox"
            checked={values.includes(a.value) }
            value={a.value}
            onChange={(e) => {
                if (!e.target.checked) return
                if (a.value==='treasury-auctions') {
                    show('tools.treasury-auctions', {from:'advanced-screener'})
                    return
                }
                remove(0)
                push(a.value)
            }}
        />
        <label className="btn btn-large" htmlFor={id}>{a.name}</label>
        </div>)
    }))}
    { err && <label className="field-status has-error" style={{textAlign:'left'}}>{err}</label> }
    </div>
    )
}

const invTypes = [
    { name: 'Corporates', value:'C' },
    { name: 'Municipals', value:'M' },
    { name: 'CDs', value:'S' },
    { name: 'Agencies', value:'A' },
    { name: 'U.S. Treasuries', value:'T' },
    { name: 'Treasury Auctions', value:'treasury-auctions' },
]



// WEBPACK FOOTER //
// ./src/advanced-screener/search-form/securities-field.js